import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Header from './components/Layout/Header/Header';
import Footer from './components/Layout/Footer/Footer';
import AuthGuard from './components/Guards/GuardAuth';
import Home from './components/Home/Home';
import CreateEmpleado from "./components/Sections/createEmpleado/CreateEmpleado";
import EditEmpleado from "./components/Sections/editEmpleado/EditEmpleado";
import DetalleEmpleadoPage from './components/Sections/detalleEmpleado/DetalleEmpleado';
import CalendarioVacaciones from './components/Sections/CalendarioVacaciones/CalendarioVacaciones';

const Router = () => (
    <BrowserRouter>
        <Header />

        <Routes>
            <Route
                path="/"
                element={
                    <AuthGuard>
                        <Home />
                    </AuthGuard>
                }
            />

            <Route
                path="/createEmpleado"
                element={
                    <AuthGuard>
                        <CreateEmpleado />
                    </AuthGuard>
                }
            />

            <Route
                path="/updateEmpleado/:idEmpleado"
                element={
                    <AuthGuard>
                        <EditEmpleado />
                    </AuthGuard>
                }
            />

            <Route
                path="/detalleEmpleado/:idEmpleado"
                element={
                    <AuthGuard>
                        <DetalleEmpleadoPage />
                    </AuthGuard>
                }
            />

            <Route
                path="/calendario"
                element={
                    <AuthGuard>
                        <CalendarioVacaciones />
                    </AuthGuard>
                }
            />
        </Routes>

        <Footer />
    </BrowserRouter>
);

export default Router;
